import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ClientService } from '../../client.service';
import { SubscriptionWithPaidFeatures, PaidFeatureScope } from '../monetization/monetization.model';
import { PurchasesApiModel, ViCarePlan } from './purchases.model';

@Injectable({ providedIn: 'root' })
export class PurchasesApi implements PurchasesApiModel {
  private readonly baseUrl = 'purchases/v1';

  constructor(private clientService: ClientService) {}

  /**
   * Get ViCare plans
   * @param installationId
   */
  getViCarePlans(installationId: number): Observable<ViCarePlan[]> {
    const endpoint = `${this.baseUrl}/installations/${installationId}/apps/vicare/features?includeInactive=true`;

    return this.clientService.get(endpoint);
  }

  /**
   * get available paid features of single installation
   * @param scope
   * @param id
   */
  getAvailablePaidFeaturesForSingleInstallation(
    scope: PaidFeatureScope,
    id: string
  ): Observable<SubscriptionWithPaidFeatures[]> {
    const endpoint = `${this.baseUrl}/apps/viguide/features?scope=${scope}&resourceId=${id}`;

    return this.clientService.get(endpoint);
  }

  /**
   * get available paid features of all installations
   */
  getAvailableInstallationsPaidFeatures(): Observable<SubscriptionWithPaidFeatures[]> {
    const endpoint = `${this.baseUrl}/apps/viguide/features`;

    return this.clientService.get(endpoint);
  }
}
